import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { BusinessAction, RBACRole } from "../../../../api/rbac/types";
import { RBACAccessContext } from "../../../../context/RBACAccessContext/RBACAccessContext";
import { UserContext } from "../../../../context/UserContext/UserContext";
import { OrderRow } from "../../AllOrders/types";
import { orderTypeToUrlParamMapping } from "../../types";

interface OrderNumberCellProps {
  value: any;
  row: OrderRow;
}

const OrderNumberCell = ({ value, row }: OrderNumberCellProps) => {
  const theme = useTheme();
  const { pathname } = useLocation();
  const user = useContext(UserContext);
  const { isRBACEnabled } = useContext(RBACAccessContext);
  const enableNavigationLinkCleanUp = true;
  const isAuthorizedToEditOrders =
    !isRBACEnabled ||
    (isRBACEnabled &&
      (user?.isAuthorizedTo(BusinessAction.EDIT_ORDER) ||
        user?.isAuthorizedTo(BusinessAction.CREATE_ORDER)));

  const isUnsubmitted = row.orderStatus?.toLowerCase() === "unsubmitted";
  const isCorporateManager =
    isRBACEnabled && user?.is(RBACRole.CORPORATE_PARTS_MANAGER);
  const summaryPageLink =
    isCorporateManager || enableNavigationLinkCleanUp
      ? `/orders/${value}`
      : `/dealer/${row.accountId}/orders/${value}`;
  let link;
  if (isUnsubmitted) {
    link = enableNavigationLinkCleanUp
      ? `/orders/create/${
          orderTypeToUrlParamMapping[row.orderType as string]
        }/${value}`
      : `/dealer/${row.accountId}/orders/create/${
          orderTypeToUrlParamMapping[row.orderType as string]
        }/${value}`;
  } else {
    link = summaryPageLink;
  }
  if (isUnsubmitted && !isAuthorizedToEditOrders)
    return (
      <Typography
        data-testid="order-number-text"
        sx={{
          fontWeight: theme.tokens.FuelFontWeightRegular,
          fontSize: "14px",
        }}
      >
        {value}
      </Typography>
    );
  return (
    <Link
      data-testid="order-summary-link"
      to={link}
      state={{
        dealerAccountId: row.accountId,
        previousPath: pathname,
      }}
    >
      <Typography
        sx={{
          color: theme.tokens.FuelColorTextBrandPrimary,
          fontWeight: theme.tokens.FuelFontWeightRegular,
          fontSize: "14px",
          textDecoration: "underLine",
          ":hover": {
            cursor: "pointer",
            color: theme.tokens.FuelColorFocused,
          },
        }}
      >
        {value}
      </Typography>
    </Link>
  );
};

export default OrderNumberCell;
